<template>
  <div class="box flex-col">
      <div v-for="(file,index) in fileList" :id="index">
        <div class="file-block flex-col" @click="downSampleInfoFile(file)">
          <div class="content">
            <img class="file-icon" :src="emkt.getOrderMaterialFileShowIcon(file.fileName)"/>
            <div class="layer2 flex-col">
              <span class="file-font">{{ file.fileName }}</span>
              <span class="file-font">{{ file.fileSizeDisplay }}</span>
            </div>
            <img class="right-icon" :src="emkt.MATERIAL_STATIC_FILE_BASE_URL + 'other/right.svg'"/>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
  import wx from 'wx'
  import EMKT from '../../emkt'
  import {mapState} from 'vuex'

  export default {
    name: 'DownloadArticleInfoSheet',
    computed: {
      ...mapState(['sessionInfo'])
    },
    created () {
      this.fetchData()
    },
    data () {
      return {
        fileList: []
      }
    },
    methods: {
      fetchData () {
        var _this = this
        _this.fileList = this.$route.params.sampleInfoFiles
      },
      downSampleInfoFile (file) {
        wx.miniProgram.navigateTo({
          url:
            '/pages/file/downloadSampleInfoFile?customerNo=' +
            this.sessionInfo.customerInfo.customerNo +
            '&fileName=' +
            file.fileName.replace('&', '%26') +
            '&fileType=' +
            EMKT.getFileSuffix(file.fileName) +
            '&fileSize=' +
            file.fileSizeDisplay +
            '&orderMaterialDetailId=' +
            file.orderMaterialDetailId
        })
      }
    }
  }
</script>

<style scoped>
  .box {
    overflow-y:scroll;
    overflow-x:hidden;
    height:100vh;
    position: relative;
    padding: 10px;
    padding-bottom: 0;
    background-color: rgba(250, 250, 250, 1);
    justify-content: flex-start;
    padding-top: 0;
  }

  .file-block {
    height: 79px;
    border-radius: 10px;
    border: 0.5px solid rgba(239, 238, 243, 1);
    background-color: rgba(255, 255, 255, 1);
    align-self: center;
    margin-top: 10px;
    width: 100%;
    justify-content: center;
    align-items: flex-start;
    padding-left: 11px;
  }

  .content {
    width: 92%;
    height: 40px;
    position: relative;
    margin-left: 12px;
    display: flex;
    flex-direction: row;
  }

  .file-icon {
    width: 44px;
    height: 40px;
  }

  .file-font {
    height: 30px;
    font-size: 12px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #424242;
    line-height: 17px;
  }

  .right-icon {
    width: 7px;
    height: 12px;
    top: 14px;
    right: 5px;
    position: absolute;
  }

  .layer2 {
    width: 100%;
    height: 36px;
    margin: 2px 0 0 10px;
  }
</style>



// WEBPACK FOOTER //
// DownloadArticleInfoSheet.vue?da41d064